export default __webpack_public_path__ + "static/media/image-light.4275e8a9.svg";